import { render, staticRenderFns } from "./SensorsErrorsTable.vue?vue&type=template&id=490b326e&scoped=true"
import script from "./SensorsErrorsTable.vue?vue&type=script&lang=js"
export * from "./SensorsErrorsTable.vue?vue&type=script&lang=js"
import style0 from "./SensorsErrorsTable.vue?vue&type=style&index=0&id=490b326e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490b326e",
  null
  
)

export default component.exports